import { useState, useEffect } from "react";
import useScrollContainer from "../../contexts/ScrollContext";
import styles from "./GoToTopButton.module.scss";

const GoToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const scrollContainerRef = useScrollContainer();

  useEffect(() => {
    const scrollElement = scrollContainerRef?.current;
    
    if (!scrollElement) {
      return;
    }

    const toggleVisibility = () => {
      if (scrollElement.scrollTop > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    scrollElement.addEventListener("scroll", toggleVisibility);

    return () => {
      scrollElement.removeEventListener("scroll", toggleVisibility);
    };
  }, [scrollContainerRef]);

  const scrollToTop = () => {
    const scrollElement = scrollContainerRef?.current;
    
    if (scrollElement) {
      scrollElement.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.container}>
      <button
        onClick={scrollToTop}
        className={styles.goToTopButton}
        aria-label="Go to top"
      >
        <span className={styles.arrow}>↑</span>
      </button>
      <span className={styles.text}>Go to Top</span>
    </div>
  );
};

export default GoToTopButton;
